module.exports = __webpack_public_path__ + "img/内容图例_2.801aa122.png";